import { isUserFacingTrpcError } from '@algoacademy/backend/trpc/client-errors'
import { toast } from 'sonner'
import { Link } from '../../actions/Link'

export function showTrpcMutationErrorToast(error: unknown) {
  if (isUserFacingTrpcError(error)) {
    toast.error('Coś poszło nie tak!', { description: error.message })
    return
  }

  showErrorToastWithContactFormLink()
}

export function showErrorToast(
  message = 'Wystąpił błąd',
  options?: Parameters<typeof toast.error>[1]
) {
  toast.error(message, options)
}

export function showErrorToastWithContactFormLink(message = 'Wystąpił błąd') {
  showErrorToast(message, {
    description: (
      <>
        Spróbuj ponownie. Jeśli problem będzie się powtarzał, skontaktuj się z nami za pomocą{' '}
        <Link href='/kontakt' className='font-semibold text-algoprimary underline'>
          formularza kontaktowego
        </Link>
        .
      </>
    )
  })
}

export function showErrorToastWithAlgoPhoneNumber() {
  showErrorToast('Coś poszło nie tak!', {
    description: (
      <>
        Spróbuj ponownie. Jeśli problem będzie się powtarzał, zadzwoń do nas na numer{' '}
        <Link href='/kontakt' className='font-semibold text-algoprimary underline'>
          789 579 079
        </Link>
        .
      </>
    )
  })
}
